import { c as _c } from "react/compiler-runtime";
import { LoadingSpinner } from '../../../../../atoms/LoadingSpinner';
export const EditorLoader = t0 => {
  const $ = _c(5);
  const {
    height
  } = t0;
  const t1 = `${height ?? 20}rem`;
  let t2;
  if ($[0] !== t1) {
    t2 = {
      height: t1
    };
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <LoadingSpinner size="lg" />;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== t2) {
    t4 = <div className="flex items-center justify-center" style={t2}>{t3}</div>;
    $[3] = t2;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  return t4;
};